import { DateTime } from 'luxon';
import { ISO8601Type, ShiftDateType } from 'types/common.types';
import { getLocalizedDateFormat } from 'utils/getLocalizedDateFormat';

export function parseDate(arg: ISO8601Type, format = 'dd, yyyy'): ShiftDateType {
  const { dayOfWeek, month } = getLocalizedDateFormat(arg);

  return `${dayOfWeek}, ${month} ${DateTime.fromISO(arg).toFormat(format)}` as ShiftDateType;
}
